(function () {
  function initOppMenu() {
    const menu = document.querySelector('[data-ag-opp-menu]');
    if (!menu) return;

    // evita inicializar 2x (editor/preview pode re-renderizar)
    if (menu.dataset.agInit === '1') return;
    menu.dataset.agInit = '1';

    const baseUrl = menu.getAttribute('data-base') || location.pathname;

    // 1) Encontrar o “host” da secção onde está a grid
    // (o wrapper típico é id="shopify-section-XXXX")
    const gridHost =
      document.querySelector('#shopify-section-main-collection-product-grid') ||
      document.querySelector('[id^="shopify-section-"] main-collection-product-grid')?.closest('[id^="shopify-section-"]') ||
      document.querySelector('[id^="shopify-section-"] .product-grid')?.closest('[id^="shopify-section-"]') ||
      document.querySelector('[id^="shopify-section-"] [data-product-grid]')?.closest('[id^="shopify-section-"]');

    if (!gridHost) {
      console.warn('AG OPP: não encontrei o wrapper da secção da grid.');
      return;
    }

    // ✅ Isto é o MAIS importante: o ID real da secção (sem “shopify-section-”)
    const sectionKey = gridHost.id.replace(/^shopify-section-/, '');

    function setActive(btn) {
      menu.querySelectorAll('.ag-opp-btn').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    }

    function buildUrl(val) {
      const u = new URL(baseUrl, location.origin);

      // mantém sort_by (e outros params úteis), exceto o nosso filtro
      const current = new URL(location.href);
      current.searchParams.forEach((v, k) => {
        if (k !== 'filter.p.m.custom.categoria_oportunidade') u.searchParams.set(k, v);
      });

      // ao mudar categoria, limpa paginação
      u.searchParams.delete('page');

      if (val) u.searchParams.set('filter.p.m.custom.categoria_oportunidade', val);
      else u.searchParams.delete('filter.p.m.custom.categoria_oportunidade');

      // ✅ pedir só a secção da grid (sem HTML inteiro)
      u.searchParams.set('sections', sectionKey);

      return u.toString();
    }

    async function swap(url) {
      gridHost.classList.add('ag-opp-loading');

      const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();

      const html = data && data[sectionKey];
      if (!html) {
        console.warn('AG OPP: a resposta não trouxe HTML para a secção:', sectionKey);
        gridHost.classList.remove('ag-opp-loading');
        return;
      }

      // O HTML devolvido inclui novamente o wrapper shopify-section-...
      const tmp = document.createElement('div');
      tmp.innerHTML = html;

      const incomingWrapper =
        tmp.querySelector('#shopify-section-' + sectionKey) || tmp.firstElementChild;

      if (!incomingWrapper) {
        console.warn('AG OPP: não consegui extrair o wrapper devolvido.');
        gridHost.classList.remove('ag-opp-loading');
        return;
      }

      // Substitui o conteúdo interno (mantém o mesmo wrapper na página)
      gridHost.innerHTML = incomingWrapper.innerHTML;

      // Atualiza URL sem “sections=…”
      const clean = new URL(url);
      clean.searchParams.delete('sections');
      window.history.pushState({}, '', clean.toString());

      gridHost.classList.remove('ag-opp-loading');

      // re-scroll para dar sensação “Temu”
      gridHost.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // alguns temas precisam de re-disparar inicializações
      document.dispatchEvent(new Event('shopify:section:load'));
    }

    menu.addEventListener('click', (e) => {
      const btn = e.target.closest('.ag-opp-btn');
      if (!btn) return;

      setActive(btn); // ✅ já confirmaste que isto funciona
      const val = btn.getAttribute('data-val') || '';
      swap(buildUrl(val));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOppMenu);
  } else {
    initOppMenu();
  }

  document.addEventListener('shopify:section:load', initOppMenu);
})();

